let withinGovernor = false;
export function getWithinGovernor(): boolean {
    return withinGovernor;
}

export function setWithinGovernor(value: boolean): void {
    withinGovernor = value;
}
